export default function EmailInput({
  value,
  onChange,
  inputId = 'email',
  label = 'Email',
  name = 'email',
  autoComplete = 'email',
  disabled = false,
  required = true,
  placeholder = 'Email',
}) {
  return (
    <>
      <label htmlFor={inputId} style={{ fontWeight: 600 }}>{label}</label>
      <input
        id={inputId}
        type="email"
        name={name}
        autoComplete={autoComplete}
        autoCapitalize="none"
        spellCheck={false}
        inputMode="email"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        required={required}
        className="form-input"
      />
    </>
  );
}
